import dayjs from "dayjs";
import { array, date, number, object, string } from "yup";
import { DiscountTypeEnum } from "@/features/shared";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  purchaseInvoiceProductVariants: [],
  purchaseInvoiceExpenses: [],
  purchaseDownPaymentAllocations: [],
  discount: 0,
  discountAmount: 0,
  discountType: DiscountTypeEnum.FIXED_AMOUNT,
  taxable: false,
  totalIncludesTax: false,
  taxAmount: 0,
  taxPercentage: 11,
  subtotal: 0,
  grandTotal: 0,
};

export const VALIDATION_SCHEMA = object().shape({
  seller: object().required("Harus diisi"),
  paymentTerm: object().required("Harus diisi"),
  transactionDate: date().required("Harus diisi"),
  sellerReferenceNumber: string().required("Harus diisi"),
  sellerBankAccount: object().nullable(),
  purchaseInvoiceProductVariants: array().min(
    1,
    "Harus memiliki setidaknya satu produk"
  ),
  purchaseInvoiceExpenses: array().of(
    object().shape({
      outletChartOfAccount: object().required("Harus diisi"),
      amount: number().min(0, "Tidak boleh negatif").required("Harus diisi"),
      note: string().nullable(),
    })
  ),
  purchaseDownPaymentAllocations: array().of(
    object().shape({
      sourcePurchaseInvoiceId: string().required("Harus diisi"),
      amount: number()
        .min(0, "Tidak boleh negatif")
        .test("max-available", "Melebihi sisa tersedia", function (value) {
          // A row without a known ceiling is uncapped rather than rejected —
          // comparing against undefined would fail every allocation.
          const { availableAmount } = this.parent;
          if (availableAmount == null) return true;
          return value == null || value <= availableAmount;
        })
        .required("Harus diisi"),
    })
  ),
});
